import { TextField as MUITextField } from '@mui/material';

type Props = {
  value?: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const DateTangePicker = ({ value, handleChange }: Props) => {
  return <MUITextField type="date" value={value} onChange={handleChange} />;
};

export default DateTangePicker;
